'use client';

import { cn } from '@workspace/lib';
import {
  ProductSlideshowDesktopSection,
  ProductSlideshowMobileSection,
  ProductSlideshowTextSection,
  ProductSlideshowNavigation,
} from './ui';
import type { ProductSlideshowProps } from './product-slideshow.types';
import { useProductSlideshow } from './useProductSlideshow';

export function ProductSlideshow({ block }: ProductSlideshowProps) {
  const { isActive, slides, isProductRight, backgroundClass, emblaRef, handleNext, handlePrev } = useProductSlideshow({
    block,
  });

  if (!isActive) return null;

  return (
    <section className={cn('product-slideshow-bg relative w-full overflow-hidden', backgroundClass)}>
      <div className="product-slideshow-container md:py-3xl py-xl px-mobile-input-y wrapper mx-auto">
        <div className="embla overflow-hidden -mx-6" ref={emblaRef}>
          <div className="embla__container flex">
            {slides?.map((slide, i) => {
              if (!slide) return null;

              return (
                <div key={i} className="embla__slide flex-[0_0_100%] min-w-0">
                  <div className="px-6 product-slideshow-wrapper w-full flex flex-col md:flex-row gap-sm md:gap-4xl items-center justify-center">
                    {/* --- Product Section (Desktop) --- */}
                    <ProductSlideshowDesktopSection slide={slide} isProductRight={isProductRight} />

                    {/* --- Text Section --- */}
                    <div className={`flex flex-col flex-1 w-full ${isProductRight ? 'md:order-1' : 'order-3'}`}>
                      <ProductSlideshowTextSection slide={slide} />

                      {/* Chevron Navigation */}
                      <ProductSlideshowNavigation
                        slidesLength={slides.length}
                        onNext={handleNext}
                        onPrev={handlePrev}
                      />
                    </div>

                    {/* --- Product Section (Mobile) --- */}
                    <ProductSlideshowMobileSection slide={slide} isProductRight={isProductRight} />
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
